// import axios from 'axios';

// export async function apiGet(path) {
//     const authToken = localStorage.getItem("token");
//     const config = {

//         headers: {
//             Authorization: authToken ? `Bearer ${authToken}` : null,
//         },
//     };
//     return axios.get(path, config);
// }
// export async function apiPost(path, data) {
//     const authToken = localStorage.getItem("token");
   
//     const config = {
//         headers: {
//             Authorization: authToken ? `Bearer ${authToken}` : null,
//             'Content-Type': 'application/json',
//         },
//     };
//     return axios.post(path, data, config);
// }

// export async function apiPost1(path, data) {
//     const authToken = localStorage.getItem("token");
//     const config = {
//         headers: {
//             Authorization: authToken ? `Bearer ${authToken}` : null,
//             'Content-Type': 'multipart/form-data;',
//         },
//     };

//     return axios.post(path, data, config);
// }


// export async function apiPut(path, data) {
//     const authToken = localStorage.getItem("token");

//     const config = {
//         headers: {
//             Authorization: authToken ? `Bearer ${authToken}` : null,
//             'Content-Type': 'application/json',
//         },
//     };

//     try {
//         const response = await axios.put(path, data, config);
//        // console.log("axios error",path, data, config)
//         return response; 
//     } catch (error) {
//         console.error('Error making PUT request:', error);
//         throw error;
//     }
// }

// export async function apiPut1(path, data) {
//     const authToken = localStorage.getItem("token");

//     const config = {
//         headers: {
//             Authorization: authToken ? `Bearer ${authToken}` : null,
//             'Content-Type': 'multipart/form-data;',
//         },
//     };

//     try {
//         const response = await axios.put(path, data, config);
//        // console.log("axios error",path, data, config)
//         return response;  // Return data or full response as needed
//     } catch (error) {
//         console.error('Error making PUT request:', error);
//         throw error;
//     }
// }

// const instance = axios.create();

// export default instance;



import axios from "axios";

let pendingRequests = 0;

const showLoader = () => {
    pendingRequests++;

    window.dispatchEvent(
        new CustomEvent("global-loader", {
            detail: true,
        })
    );
};

const hideLoader = () => {
    pendingRequests--;

    if (pendingRequests <= 0) {
        pendingRequests = 0;

        window.dispatchEvent(
            new CustomEvent("global-loader", {
                detail: false,
            })
        );
    }
};

const getConfig = (contentType = "application/json") => {
    const authToken = localStorage.getItem("token");

    return {
        headers: {
            Authorization: authToken ? `Bearer ${authToken}` : "",
            "Content-Type": contentType,
        },
    };
};


export async function apiGet(path) {
    showLoader();

    try {
        return await axios.get(path, getConfig());
    } finally {
        hideLoader();
    }
}

export async function apiPost(path, data) {
    showLoader();

    try {
        return await axios.post(path, data, getConfig());
    } finally {
        hideLoader();
    }
}
export async function apiPost1(path, data) {
    showLoader();

    try {
        return await axios.post(
            path,
            data,
            getConfig("multipart/form-data")
        );
    } finally {
        hideLoader();
    }
}


export async function apiPut(path, data) {
    showLoader();

    try {
        return await axios.put(path, data, getConfig());
    } catch (error) {
        console.error("PUT Error :", error);
        throw error;
    } finally {
        hideLoader();
    }
}


export async function apiPut1(path, data) {
    showLoader();

    try {
        return await axios.put(
            path,
            data,
            getConfig("multipart/form-data")
        );
    } catch (error) {
        console.error("PUT Error :", error);
        throw error;
    } finally {
        hideLoader();
    }
}

const instance = axios.create();

export default instance;